import React, { useState, useEffect } from 'react';
import { collection, query, onSnapshot } from 'firebase/firestore';
import { db, appId } from '../firebase';
import { StatCard } from './SharedComponents';
import { Clock, DollarSign, CheckCircle, AlertTriangle } from 'lucide-react';

const Dashboard = () => {
    const [stats, setStats] = useState({
        pendientesCount: 0,
        montoPendiente: 0,
        recaudadoMes: 0,
        infraccionTop: 'N/A'
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const pathMultas = `artifacts/${appId}/public/data/multas`;
        const qMultas = query(collection(db, pathMultas));
        const unsubscribeMultas = onSnapshot(qMultas, (multasSnapshot) => {
            const multasData = multasSnapshot.docs.map(doc => doc.data());
            
            const pathInfracciones = `artifacts/${appId}/public/data/tipos_infraccion`;
            const qInfracciones = query(collection(db, pathInfracciones));
            const unsubscribeInfracciones = onSnapshot(qInfracciones, (infraccionesSnapshot) => {
                const infraccionesData = infraccionesSnapshot.docs.map(doc => ({id: doc.id, ...doc.data()}));
                
                const multasPendientes = multasData.filter(m => m.estado === 'pendiente');
                const pendientesCount = multasPendientes.length;
                const montoPendiente = multasPendientes.reduce((sum, m) => sum + Number(m.monto), 0);

                const ahora = new Date();
                const mesActual = ahora.getMonth();
                const anioActual = ahora.getFullYear();
                
                const recaudadoMes = multasData
                    .filter(m => {
                        if (m.estado !== 'pagada' || !m.fecha_pago) return false;
                        const fechaPago = new Date(m.fecha_pago);
                        return fechaPago.getMonth() === mesActual && fechaPago.getFullYear() === anioActual;
                    })
                    .reduce((sum, m) => sum + Number(m.monto), 0);

                let infraccionTop = 'Ninguna';
                if (multasData.length > 0) {
                    const conteo = multasData.reduce((acc, m) => {
                        acc[m.tipo_infraccion_id] = (acc[m.tipo_infraccion_id] || 0) + 1;
                        return acc;
                    }, {});
                     if (Object.keys(conteo).length > 0) {
                        const topId = Object.keys(conteo).reduce((a, b) => conteo[a] > conteo[b] ? a : b);
                        const topInfraccionData = infraccionesData.find(i => i.id === topId);
                        if (topInfraccionData) {
                             infraccionTop = `${topInfraccionData.codigo}`;
                        }
                    }
                }

                setStats({
                    pendientesCount,
                    montoPendiente,
                    recaudadoMes,
                    infraccionTop,
                });
                setLoading(false);
            });
            return () => unsubscribeInfracciones();
        });
        return () => unsubscribeMultas();
    }, []);

    return (
         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <StatCard 
                title="Multas Pendientes" 
                value={stats.pendientesCount} 
                icon={<Clock size={40} />} 
                variant="yellow"
                loading={loading}
            />
            <StatCard 
                title="Monto Pendiente" 
                value={`S/ ${stats.montoPendiente.toFixed(2)}`} 
                icon={<DollarSign size={40} />} 
                variant="red"
                loading={loading}
            />
            <StatCard 
                title="Recaudado este Mes" 
                value={`S/ ${stats.recaudadoMes.toFixed(2)}`} 
                icon={<CheckCircle size={40} />} 
                variant="green"
                loading={loading}
            />
            <StatCard 
                title="Infracción más Común" 
                value={stats.infraccionTop} 
                icon={<AlertTriangle size={40} />} 
                variant="blue"
                loading={loading}
            />
        </div>
    );
};

export default Dashboard;